<!-- form title -->
<div class="w-12">
    <ng-form #form="ngForm"
             novalidate="true">
        @if (model?.data) {
        <!-- form body -->
        @for (field of fields; track field; let first = $first) {
        @if(!field.is_hidden_field) {
        @switch(field.field_type) {
        @case('address') {
        <address-fieldset [form]="form"
                          [data]="addressData"
                          [showCountry]="field.show_country"
                          [showOnlyAddress]="true"></address-fieldset>
        }
        @default {
        <div class="m-t m-b"
             [ngClass]="'w-' + field.wrappercol">
            @switch (field.field_type) {
            <!-- input: text -->
            @case ('text') {
            <form-mui-field [label]="field.label | translate">
                <input type="text"
                       [name]="field.cid"
                       [required]="!!field.required"
                       [(ngModel)]="data[field.cid]"
                       [placeholder]="(field.placeholder | translate )|| ''">
            </form-mui-field>
            }
            <!-- input: number -->
            @case ('number') {
            <form-mui-field [label]="field.label | translate">
                <input type="number"
                       [name]="field.cid"
                       [required]="!!field.required"
                       [(ngModel)]="data[field.cid]"
                       [placeholder]="(field.placeholder | translate) || ''">
            </form-mui-field>
            }
            <!-- input: email -->
            @case ('email') {
            <form-mui-field [label]="field.label | translate">
                <input type="email"
                       validatePattern="email"
                       [name]="field.cid"
                       [required]="!!field.required"
                       [(ngModel)]="data[field.cid]"
                       [placeholder]="(field.placeholder | translate) || ''">
            </form-mui-field>
            }
            <!-- input: textarea -->
            @case ('paragraph') {
            <form-mui-field [label]="field.label | translate">
                <textarea [name]="field.cid"
                          [required]="!!field.required"
                          [(ngModel)]="data[field.cid]"
                          [placeholder]="(field.placeholder | translate) || ''"></textarea>
            </form-mui-field>
            }
            <!-- input: select -->
            @case ('dropdown') {
            <form-mui-field [label]="field.label | translate">
                <select [name]="field.cid"
                        [required]="!!field.required"
                        [(ngModel)]="data[field.cid]">
                    @if (field.field_options?.include_blank_option) {
                    <option value=""
                            disabled
                            selected>{{(field.placeholder | translate) || ( 'Select %' | translate: field.label )}}
                    </option>
                    }
                    @for (option of field.field_options?.options; track $index) {
                    <option [value]="option.label">{{option.label | translate}}</option>
                    }
                </select>
            </form-mui-field>
            }
            }
        </div>

        <!-- input: checkbox -->
        @if(field.field_type === 'checkboxes') {
        <p class="p1 m-b">{{field.label | translate}}</p>
        <form-field>
            @for (option of field.field_options?.options; track $index; let i = $index) {
            <checkbox>
                <input type="checkbox"
                       [(ngModel)]="data[field.cid][i]"
                       (ngModelChange)="onCheckboxesChange(field)"
                       [required]="!!field.required"
                       [name]="field.cid + '[]'">
                {{option.label | translate}}
            </checkbox>
            }
        </form-field>
        }

        <!-- input: subscription checkbox -->
        @if(field.field_type === 'subscription') {
        <form-field>
            <checkbox>
                <input type="checkbox"
                       [name]="field.cid"
                       [required]="!!field.required"
                       [(ngModel)]="data[field.cid]">{{field.field_options?.options[0].label | translate}}
            </checkbox>
        </form-field>
        }

        <!-- input: radio -->
        @if(field.field_type === 'radio') {
        <p class="p1 m-b">{{field.label | translate}}</p>
        <radio-group class="flex-column"
                     [name]="field.cid"
                     [required]="!!field.required"
                     [(model)]="data[field.cid]">
            @for (option of field.field_options?.options; track $index; let i = $index) {
            <radio-group-item class="w-12 m-t-2"
                              [value]="option.label">
                <span [innerHtml]="option.label | translate"></span>
            </radio-group-item>
            }
        </radio-group>
        }

        <!-- section_break -->
        @if(field.field_type === 'section_break') {
        <div class="block p-t-1 p-b-1">
            <span ng-bind="::field.label"></span>
        </div>
        }

        <!-- input: file_upload -->
        @if(field.field_type === 'file_upload') {
        <p class="p1 m-b">{{field.label | translate}}</p>
        <single-file-upload [name]="field.cid"
                            [label]="field.label | translate"
                            [required]="!!field.required"
                            [accept]="field.image_type"
                            [maxSize]="field.image_maximum_size ? field.image_maximum_size + 'MB' : undefined"
                            [dragDropText]="field.drag_drop_text"
                            [openBrowserText]="field.open_browser_text"
                            [(file)]="data[field.cid]"
                            (fileChange)="detectChanges()">
        </single-file-upload>
        }

        <!-- input: multifile_upload -->
        @if(field.field_type === 'multifile_upload') {
        <p class="p1 m-b">{{field.label | translate}}</p>
        <multi-file-upload [name]="field.cid"
                           [label]="field.label | translate"
                           [required]="!!field.required"
                           [accept]="field.image_type"
                           [maxSize]="field.image_maximum_size ? field.image_maximum_size + 'MB' : undefined"
                           [maxFiles]="field.file_number_limit"
                           [dragDropText]="field.drag_drop_text"
                           [openBrowserText]="field.open_browser_text"
                           [(files)]="data[field.cid]"
                           (filesChange)="detectChanges()">
        </multi-file-upload>
        }
        }
        }
        @if(field.field_options?.description) {
        <p class="m-t-2 p1">{{field.field_options?.description | translate}}</p>
        }
        }
        }

        <!-- submit button -->
        <div class="w-12 center m-t-6">
            <button [status]="status"
                    [buttonStyle]
                    class="w-12"
                    (click)="submit()">{{(model.data?.submit_button_text || 'Send') | translate}}</button>
            <!-- submission result -->
            @if (model.data?.success_message) {
            <result [status]="status"
                    [success]="model.data?.success_message || ''"
                    class="block m-t-3"></result>
            }
        </div>
        }
    </ng-form>
</div>
